import { TrueNorthPortraitCardData } from './true-north-portrait-card-data';

export class TrueNorthLandscapeCardData extends TrueNorthPortraitCardData {}
